const DB_NAME = 'installer_cache_v2';
const DB_VERSION = 1;
const STORE = 'entries';

const openDb = () =>
    new Promise((resolve, reject) => {
        if (typeof indexedDB === 'undefined') {
            reject(new Error('IndexedDB недоступен'));
            return;
        }
        const req = indexedDB.open(DB_NAME, DB_VERSION);
        req.onupgradeneeded = () => {
            const db = req.result;
            if (!db.objectStoreNames.contains(STORE)) {
                db.createObjectStore(STORE, { keyPath: 'key' });
            }
        };
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
    });

const withStore = async (mode, fn) => {
    const db = await openDb();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(STORE, mode);
        const store = tx.objectStore(STORE);
        let result;
        tx.oncomplete = () => resolve(result);
        tx.onerror = () => reject(tx.error || new Error('IDB'));
        try {
            const maybe = fn(store);
            if (maybe && typeof maybe.then === 'function') {
                maybe.then(value => {
                    result = value;
                }).catch(reject);
            } else {
                result = maybe;
            }
        } catch (error) {
            reject(error);
        }
    });
};

const putEntry = async (key, value) => {
    const row = {
        key,
        value,
        savedAt: Date.now()
    };
    await withStore('readwrite', store => {
        store.put(row);
    });
    return row;
};

const getEntry = async key => {
    try {
        return await withStore('readonly', store =>
            new Promise((resolve, reject) => {
                const req = store.get(key);
                req.onsuccess = () => resolve(req.result || null);
                req.onerror = () => reject(req.error);
            })
        );
    } catch (_) {
        return null;
    }
};

export const getInstallerUser = () => {
    try {
        return JSON.parse(localStorage.getItem('user') || 'null');
    } catch (_) {
        return null;
    }
};

export const installerUserLabel = user => {
    const row = user || getInstallerUser() || {};
    const name = [row.last_name, row.first_name, row.middle_name]
        .filter(Boolean)
        .join(' ')
        .trim();
    return name || row.login || `ID ${row.id || '—'}`;
};

const userKey = () => {
    const user = getInstallerUser();
    return String(user?.id || 'anon');
};

export const saveCachedReport = async ({
    dateFrom,
    dateTo,
    report
}) => {
    const uid = userKey();
    const payload = {
        dateFrom: dateFrom || null,
        dateTo: dateTo || null,
        report
    };
    await putEntry(`report:${uid}:${dateFrom || ''}:${dateTo || ''}`, payload);
    await putEntry(`report:${uid}:last`, payload);
};

export const loadCachedReport = async ({
    dateFrom,
    dateTo
} = {}) => {
    const uid = userKey();
    const exact = await getEntry(
        `report:${uid}:${dateFrom || ''}:${dateTo || ''}`
    );
    if (exact?.value?.report) {
        return {
            ...exact.value,
            savedAt: exact.savedAt
        };
    }
    const last = await getEntry(`report:${uid}:last`);
    if (last?.value?.report) {
        return {
            ...last.value,
            savedAt: last.savedAt
        };
    }
    return null;
};

export const saveCachedWork = async (taskId, bundle, taskCard) => {
    if (!taskId) return;
    await putEntry(`work:${userKey()}:${taskId}`, {
        bundle,
        taskCard: taskCard || null
    });
};

export const loadCachedWork = async taskId => {
    if (!taskId) return null;
    const row = await getEntry(`work:${userKey()}:${taskId}`);
    return row?.value || null;
};

export const saveCachedTmc = async ({ holdings, pendingIssues }) => {
    await putEntry(`tmc:${userKey()}`, {
        holdings: holdings || [],
        pendingIssues: pendingIssues || []
    });
};

export const loadCachedTmc = async () => {
    const row = await getEntry(`tmc:${userKey()}`);
    return row
        ? { ...row.value, savedAt: row.savedAt }
        : null;
};
